import { Enrollment } from '@clear-denver/tpc-openapi-typescript'

export function getDisplayName(name: Enrollment.NameObject): string {
  const { firstName, middleName, noMiddleName, lastName } = name
  const displayName =
    noMiddleName === false
      ? `${firstName} ${middleName} ${lastName}`
      : `${firstName} ${lastName}`

  return displayName
}
